import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"

interface Props {
  className?: string
}

export function ShareIcon(props: Props) {
  const { _ } = useLingui()

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="24 / share">
        <title>{_(msg`Share Icon`)}</title>
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.53717 7.53044C9.24427 7.82334 8.7694 7.82334 8.47651 7.53044C8.18361 7.23755 8.18361 6.76268 8.47651 6.46978L11.4765 3.46978L12.0068 2.93945L12.5372 3.46978L15.5372 6.46978C15.8301 6.76268 15.8301 7.23755 15.5372 7.53044C15.2443 7.82334 14.7694 7.82334 14.4765 7.53044L12.7568 5.81077V15.0001C12.7568 15.4143 12.421 15.7501 12.0068 15.7501C11.5926 15.7501 11.2568 15.4143 11.2568 15.0001V5.81077L9.53717 7.53044ZM8.63184 11.7501C7.5963 11.7501 6.75684 12.5896 6.75684 13.6251V16.0001C6.75684 17.2428 7.7642 18.2501 9.00684 18.2501H15.0068C16.2495 18.2501 17.2568 17.2428 17.2568 16.0001V13.6251C17.2568 12.5896 16.4174 11.7501 15.3818 11.7501C14.9676 11.7501 14.6318 11.4143 14.6318 11.0001C14.6318 10.5859 14.9676 10.2501 15.3818 10.2501C17.2458 10.2501 18.7568 11.7612 18.7568 13.6251V16.0001C18.7568 18.0712 17.0779 19.7501 15.0068 19.7501H9.00684C6.93577 19.7501 5.25684 18.0712 5.25684 16.0001V13.6251C5.25684 11.7612 6.76787 10.2501 8.63184 10.2501C9.04605 10.2501 9.38184 10.5859 9.38184 11.0001C9.38184 11.4143 9.04605 11.7501 8.63184 11.7501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
